import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackGooglePlayClick } from "../analytics/googleAnalytics";
import "./MoneyPages.css";

export default function MacrosApp() {
  return (
    <>
      <Helmet>
        <title>App para Contar Macros Gratis en 2026 | Wayo - Proteína, Carbs y Grasas</title>
        <meta
          name="description"
          content="Controla proteína, carbohidratos y grasas sin registro manual. Wayo calcula tus macros con una foto. La app de macros más fácil y gratis en 2026."
        />
        <meta
          name="keywords"
          content="app para contar macros, contador de macros, app macros gratis, seguir macros, proteina carbohidratos grasas, app macronutrientes, dieta macros"
        />
        <link rel="canonical" href="https://wayoai.app/app-para-contar-macros" />
      </Helmet>

      <main className="money-page">
        <Header />
        <div className="money-shell">
          <section className="money-hero">
            <div className="money-copy">
              <span className="money-badge">App para contar macros</span>
              <h1>Macros claros. Menos tiempo registrando.</h1>
              <p>
                Si quieres seguir proteína, carbohidratos y grasas sin convertir cada comida en una tarea,
                necesitas una app para contar macros que sea <strong>rápida, práctica y fácil de sostener</strong>.
              </p>

              <div className="money-highlights">
                <div className="money-highlight">
                  <span>💪</span>
                  <div>
                    <strong>Útil para definición y volumen</strong>
                    <span>Controla macros sin perder media vida registrando cada plato.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>📸</span>
                  <div>
                    <strong>Más cómoda con comida real</strong>
                    <span>Mejor experiencia que depender solo de búsqueda manual y barras.</span>
                  </div>
                </div>
                <div className="money-highlight">
                  <span>⚡</span>
                  <div>
                    <strong>Adherencia real</strong>
                    <span>Cuando cuesta menos registrar, es más fácil llegar al objetivo.</span>
                  </div>
                </div>
              </div>

              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("macros_app_hero")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("macros_app_hero")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
            </div>

            <div className="money-visual">
              <span className="money-score">Pensada para seguir macros</span>
              <div className="money-visual-card">
                <h3>Qué buscas de verdad en una app de macros</h3>
                <ul>
                  <li>Ver proteína, carbohidratos y grasas rápido</li>
                  <li>No abandonar por exceso de pasos</li>
                  <li>Poder registrar platos reales y no solo envasados</li>
                  <li>Tener una herramienta útil tanto si defines como si haces volumen</li>
                </ul>
              </div>
              <div className="money-mini-grid">
                <div className="money-mini-card">
                  <strong>Macros</strong>
                  <span>Seguimiento más simple para quien quiere resultados y constancia.</span>
                </div>
                <div className="money-mini-card">
                  <strong>Fácil</strong>
                  <span>La mejor app no es la más compleja, sino la que sigues usando.</span>
                </div>
              </div>
            </div>
          </section>

          <div className="money-sections">
            <section className="money-section">
              <h2>Qué debe tener una buena app para contar macros</h2>
              <ul>
                <li>Registro rápido de comida</li>
                <li>Visualización clara de proteína, carbohidratos y grasas</li>
                <li>Buen encaje con platos caseros</li>
                <li>Experiencia sencilla para principiantes</li>
                <li>Capacidad de mantener el hábito semanas seguidas</li>
              </ul>
            </section>

            <section className="money-section">
              <h2>Qué opción encaja mejor según tu objetivo</h2>
              <table className="money-table">
                <thead>
                  <tr>
                    <th>Perfil</th>
                    <th>Qué necesita</th>
                    <th>Qué suele encajar mejor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Principiante</td>
                    <td>Algo fácil de seguir y sin agobio</td>
                    <td>Wayo</td>
                  </tr>
                  <tr>
                    <td>Definición</td>
                    <td>Control práctico de macros y constancia</td>
                    <td>Wayo o apps clásicas según tolerancia al registro manual</td>
                  </tr>
                  <tr>
                    <td>Volumen</td>
                    <td>Ver totales sin fricción diaria</td>
                    <td>Wayo</td>
                  </tr>
                  <tr>
                    <td>Perfil muy técnico</td>
                    <td>Más detalle y micronutrientes</td>
                    <td>Cronometer</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="money-cta">
              <h3>Si contar macros te agota, el problema no eres tú: es la fricción.</h3>
              <p>
                La mejor app para macros es la que te deja centrarte en comer mejor y entrenar, no en rellenar pantallas.
              </p>
              <div className="money-store-row">
                <a
                  className="money-store-badge"
                  href="https://apps.apple.com/app/id6756500478"
                  onClick={() => trackAppStoreClick("macros_app_mid")}
                >
                  <img src={appStoreImg} alt="Descargar Wayo en App Store" />
                </a>
                <a
                  className="money-store-badge"
                  href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
                  onClick={() => trackGooglePlayClick("macros_app_mid")}
                >
                  <img src={googlePlayImg} alt="Descargar Wayo en Google Play" />
                </a>
              </div>
            </section>

            <section className="money-section">
              <h2>Preguntas frecuentes</h2>
              <div className="money-faq-grid">
                <div className="money-faq-item">
                  <h3>¿Sirve para proteína y pérdida de grasa?</h3>
                  <p>Sí. Precisamente una app de macros ayuda mucho cuando quieres perder grasa sin perder músculo.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Necesito pesar todo?</h3>
                  <p>No necesariamente. Cuanto más fácil sea registrar, más sostenible será el hábito.</p>
                </div>
                <div className="money-faq-item">
                  <h3>¿Puede usarse si soy principiante?</h3>
                  <p>Sí. De hecho, conviene empezar con una herramienta sencilla en vez de una excesivamente técnica.</p>
                </div>
              </div>
              <div className="money-inline-links">
                <Link to="/blog/mejores-apps-para-contar-macros-2026">Ver comparativa completa de apps para macros</Link>
                <Link to="/app-para-contar-calorias-con-foto">Ver app para calorías con foto</Link>
                <Link to="/alternativa-myfitnesspal">Ver alternativa a MyFitnessPal</Link>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}
